import React from 'react';
import { dimensionNames, dimensionsNamesDisplay } from '../utils/variables';
import SliderSolo from './SliderSolo';


function KnobSetDim(props) {

    return (
        <div className='flex-inline justify-center'>
            <div className='flex'>
                <div className='flex-inline pt-4'>
                    {dimensionNames.map((dimension, index)=>(
                        <div key={index} className='my-0 md:my-2'>
                            <SliderSolo type="dim"
                                        name={dimensionsNamesDisplay[index]}
                                        value={props.dimensionsPct[dimension+'_pct_get']}
                                        sliderChange = {props.sliderChange}/>
                        </div>
                    ))}
                </div>
            </div>
        </div>
     );
}

export default KnobSetDim;
